import { NotificationEventEnum } from '.'
import { RFIStatus } from '../statuses/rfi'
import { NotificationEventItem } from './NotificationEventItem'
import { CommentedNotificationEventItem } from './common/commented'
import { EditedNotificationEventItem } from './common/edited'
import { RevertedNotificationEventItem } from './common/reverted'

const rfi = 'Request For Information' as const

const Submitted = new NotificationEventItem({
  id: '7168af2c-168f-4906-a169-f5b59fc44341',
  name: 'Submitted',
  description: `A ${rfi} is sent from ${RFIStatus.Draft.name} to ${RFIStatus.PendingResponses.name}`,
})

const Edited = EditedNotificationEventItem({
  id: '532a9c44-2dfe-4496-81e1-b1b45ec3a5a9',
  editable: rfi,
})

const Reverted = RevertedNotificationEventItem({
  id: 'b7959e84-ccd9-4805-b16b-547cba8d2f24',
  revertable: rfi,
  from: [RFIStatus.Closed, RFIStatus.Unlocked, RFIStatus.PendingResponses],
  to: [RFIStatus.PendingResponses, RFIStatus.Draft],
})

const Response = new NotificationEventItem({
  id: 'a41fc361-30f1-4a84-a537-d643b81ae323',
  name: 'Response',
  description: `A response is made to a ${rfi}`,
})

const Closed = new NotificationEventItem({
  id: 'ef5258d4-48a1-4afa-87f1-f876f69a250b',
  name: 'Closed',
  description: 'All Response Disciplines mark their responses as complete',
})

const Commented = CommentedNotificationEventItem({
  id: '33a0989b-ab27-4436-9f7a-ca42c130d105',
  commentable: rfi,
})

export type RFINotificationEventItem =
  | typeof Submitted
  | typeof Edited
  | typeof Reverted
  | typeof Response
  | typeof Closed
  | typeof Commented

class RFINotificationEventEnum extends NotificationEventEnum<
  'RFINotification',
  RFINotificationEventItem,
  RFINotificationEventItem['name'],
  RFINotificationEventItem['id']
> {
  readonly typename = 'RFINotification'
  get values() {
    return [
      this.Submitted,
      this.Edited,
      this.Reverted,
      this.Response,
      this.Closed,
      this.Commented,
    ]
  }
  readonly Submitted = Submitted
  readonly Edited = Edited
  readonly Reverted = Reverted
  readonly Response = Response
  readonly Closed = Closed
  readonly Commented = Commented
}

export const RFINotificationEvent = new RFINotificationEventEnum()
